module.exports = __webpack_public_path__ + "static/media/img6.f05ad95e.jpg";